import React from 'react';
import SelectFieldCheckbox from './Selectors/SelectFieldCheckbox';
import FinalizeJobsNoLongerReadyNote from '../../../Contents/Operations/TpClientInvoice/FinalizeJobsNoLongerReadyNote';
import { getJobsNoLongerReadyChoiceOptions } from '../../../Helpers/finalizeJobsNoLongerReadyHelper';

// The Finalize window's choice of what to do with the shops on the invoice that no longer pass the Ready for Invoicing
// rules (InputTypesEnum.JobsNoLongerReadyChoiceSelect), with those shops listed under it from the moment the window
// opens, read from the edited item (JobsNoLongerReady). The list is part of the field, not its info, because a field
// shows its validation message in the place of its info. Keep is offered only to a user who may keep them. onChange
// gets the field's name and the chosen value, as a select's does.
export default function JobsNoLongerReadyChoiceSelect({
  value = null,
  className = 'w-100 form-control form-control-sm',
  fieldName = '',
  onChange = (changedFieldName, newValue) => {},
  filterCleared = false,
  editedItem = null,
}) {
  return (
    <div className='w-100'>
      <SelectFieldCheckbox
        value={value}
        className={className}
        fieldName={fieldName}
        onChange={onChange}
        filterCleared={filterCleared}
        selectValues={getJobsNoLongerReadyChoiceOptions()}
      />
      <div className='jobs-no-longer-ready-note'>
        <FinalizeJobsNoLongerReadyNote jobs={editedItem?.JobsNoLongerReady ?? []} />
      </div>
    </div>
  );
}
